import React, { useEffect, useState } from 'react'
import CMS from '../../../components/cms/CMS'
import PageBanner from '../../../components/general/PageBanner'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { fetchSliderGetAllByGroup } from '../../../redux/slices/sliderGetAllByGroupSlice'
import { fetchSliderGroupGet } from '../../../redux/slices/sliderGroupGetSlice'
import { fetchSliderDelete } from '../../../redux/slices/sliderDeleteSlice'
import { fetchSliderSort } from '../../../redux/slices/sliderSortSlice'
import CrudSlider from './CrudSlider'
import { SortableList } from '../../../components/form/SortedBy'

const SlidersPage = () => {
    const [modal, setModal] = useState(false)
    const [changed, setChanged] = useState(false)
    const [selectedItem, setSelectedItem] = useState(0)
    const slider = useSelector((state) => state.sliderGroupGet.data)
    const lang = useSelector((state) => state.lang.lang)
    const status = useSelector((state) => state.sliderGetAllByGroup.status)
    const slidersByGroup = useSelector((state) => state.sliderGetAllByGroup.data)
    const dispatch = useDispatch()
    const { t } = useTranslation()
    const { id } = useParams()

    const getData = async () => {
        await dispatch(fetchSliderGetAllByGroup({ id: id }))
        await dispatch(fetchSliderGroupGet({ id: id }))
    }

    const deleteData = async (id) => {
        await dispatch(fetchSliderDelete({ id: id }))
        getData()
    }

    const handleSorted = (newList) => {
        slidersByGroup.forEach(async (oldItem, oldIndex) => {
            const newIndex = newList.findIndex(item => item.id === oldItem.id);
            await dispatch(fetchSliderSort({ id: oldItem.id, sort: newIndex + 1 }))
            setChanged(true)
            getData()
        });
    };

    useEffect(() => {
        getData()
    }, [dispatch, id, changed])

    return (
        <CMS>
            {
                slider ? <>
                    <PageBanner
                        modal={modal}
                        setModal={setModal}
                        title={slider?.title[lang]}
                        description={t("slider_management_desct")}
                        buttonText={t("slider_add")}
                    />

                    {status === "succeeded" ?
                        <SortableList
                            setModal={setModal}
                            list={slidersByGroup ? [...slidersByGroup].sort((a, b) => a.sort - b.sort) : []}
                            onChange={handleSorted}
                            setChanged={setChanged}
                            deleteData={deleteData}
                            contentUrl="/slider-content"
                            setSelectedItem={setSelectedItem}
                        /> : null
                    }

                    <CrudSlider
                        showMenu={modal}
                        setShowMenu={setModal}
                        setChanged={setChanged}
                        setSelectedItem={setSelectedItem}
                        lang={lang}
                        id={id}
                        selectedItem={selectedItem}
                        t={t}
                    />
                </> : null
            }
        </CMS>
    )
}

export default SlidersPage
